import questions from './includes/questions';
import FAQS from './includes/FAQS';
//import './includes/covid-nav'


window.onload = () => {
  const chatBtn = document.querySelector(".chat-btn");
  const moxieBtn = document.querySelector(".con-icon");

  chatBtn.addEventListener("click", (e) => {
    e.preventDefault();
    if (moxieBtn) {
      moxieBtn.click();
    }
  });
};

function switchTabs(t) {
    if (t.classList.contains('active')) {
        return null;
    }
    const active = document.querySelector('.tab.active');
    const inactive = document.querySelector('.tab.inactive');
    const activeCopy = document.querySelector('.copy.active');
    const inactiveCopy = document.querySelector('.copy.inactive');

    active.classList.add('inactive');
    active.classList.remove('active');
    inactive.classList.add('active');
    inactive.classList.remove('inactive');
    activeCopy.classList.add('inactive');
    activeCopy.classList.remove('active');
    inactiveCopy.classList.add('active');
    inactiveCopy.classList.remove('inactive');

    return null;
}

document.addEventListener('click', e => {
    const target = e.target;

    if (target.classList.contains('tab')) {
        switchTabs(target);
    }
});


window.onload = () => {
    const chatBtn = document.querySelector(".additional-questions-chat-button");
    const moxieBtn = document.querySelector(".con-icon");
  
    chatBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (moxieBtn) {
        moxieBtn.click();
      }
    });
  };

const selectedDays = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 
                      'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

const days = [
  {
    label: 'SUNDAY',
    value: 0
  },
  {
    label: 'MONDAY',
    value: 1
  },
  {
    label: 'TUESDAY',
    value: 2
  },
  {
    label: 'WEDNESDAY',
    value: 3
  },
  {
    label: 'THURSDAY',
    value: 4
  },
  {
    label: 'FRIDAY',
    value: 5
  },
  {
    label: 'SATURDAY',
    value: 6
  },
];

let jamaicaFirstTime = true;
let turksFirstTime = true;

$(document).ready(function() {

  //JAMAICA
  $("#jamaica-days").change(function() {
    let selectedValue = Number($(this).val());
    
    if(selectedValue != -1) {
      let selectedDay = selectedValue + 5;
    
      let optionsBody = "";
      for (let i = 0; i < days.length; i++) {
        optionsBody += `<option value='${days[i].value}'>${days[i].label}</option>`;
      }

      if(jamaicaFirstTime) {
        $("#jamaica-days").html(optionsBody);
        jamaicaFirstTime = false;

        $("#jamaica-days").val(selectedValue);
      }

      $('#take-exam-on-jamaica-container').removeClass('hide-content');
      $('#take-exam-on-jamaica').val(selectedDays[selectedDay]);
    }
  });
  //JAMAICA

  //TURKS
  $("#turks-days").change(function() {
    let selectedValue = Number($(this).val());
    
    if(selectedValue != -1) {
      let selectedDay = selectedValue + 5;
    
      let optionsBody = "";
      for (let i = 0; i < days.length; i++) {
        optionsBody += `<option value='${days[i].value}'>${days[i].label}</option>`;
      }

      if(turksFirstTime) {
        $("#turks-days").html(optionsBody);
        turksFirstTime = false;

        $("#turks-days").val(selectedValue);
      }

      $('#take-exam-on-turks-container').removeClass('hide-content');
      $('#take-exam-on-turks').val(selectedDays[selectedDay]);
    }
  });
  //TURKS

});